var friendModules = {
  namespaced: true,
  state: {
    friendList: [],
    createGroupModelVisible: false
  },
  mutations: {
    upadteFriendList: function upadteFriendList(state, friendList) {
      state.friendList = friendList;
    },
    reset: function reset(state) {
      Object.assign(state, {
        friendList: [],
        createGroupModelVisible: false
      });
    }
  }
};
export default friendModules;